import styled from 'styled-components';

export const VerifyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
